import React, { FC, useEffect, useRef, useState } from 'react';
import { FaCircleUser } from 'react-icons/fa6';
import { IoCaretDown } from 'react-icons/io5';

import * as Styles from './_authUserProfileCard.module.scss';
import Image from '~components/atoms/Image';
import Text from '~components/atoms/Text';
import { useAppDispatch } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

type TAuthUserProfileCardProps = {
    imageSrc?: string;
    text1: string;
    text2: string;
}

const AuthUserProfileCard: FC<TAuthUserProfileCardProps> = ({
    imageSrc,
    text1,
    text2,
}) => {
    const dispatch = useAppDispatch();

    const [showLogout, setShowLogout] = useState(false);

    let activeLogoutRef: HTMLDivElement | null = null;
    const logoutRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Global click handler
        const handleGlobalClick = (event: MouseEvent) => {
            if (!(event.target instanceof HTMLElement)) return;

            // If clicking inside current dropdown container, do nothing
            if (containerRef.current?.contains(event.target)) {
                return;
            }

            // If clicking outside and this button is open, close it
            if (logoutRef.current === activeLogoutRef) {
                setShowLogout(false);
                activeLogoutRef = null;
            }
        };

        document.addEventListener('mousedown', handleGlobalClick);
        return () => {
            document.removeEventListener('mousedown', handleGlobalClick);
        };
    }, []);

    const handleSignOutClick = () => {
        dispatch(combinedActions.authLogoutAttempt());
    };

    const renderAvatar = () => {
        const size = 40;

        if (!imageSrc) return <FaCircleUser size={size}/>;

        return (
            <Image
                src={imageSrc}
                width={size}
                height={size}
            />
        );
    };

    return (
        <div
            ref={containerRef}
            className={Styles.container}
            onClick={() => setShowLogout(!showLogout)}
        >
            {renderAvatar()}

            <div
                className={Styles.subcontainer}
            >
                <Text
                    label={text1}
                    className={Styles.text}
                />

                <div className={Styles.flex}>
                    <Text
                        label={text2}
                        className={Styles.text}
                    />

                    <IoCaretDown />
                </div>

                <div
                    className={`${showLogout ? Styles.block : Styles.hidden} ${Styles['logout-button']}`}
                    onClick={handleSignOutClick}
                >
                    <Text
                        label='Sign Out'
                        className={Styles['logout-button-text']}
                    />
                </div>
            </div>
        </div>
    );
};

export default AuthUserProfileCard;
